export default __webpack_public_path__ + "static/media/EVENTS.01e0399e.jpg";